import { useState, useEffect } from 'react';
import { supabase, isDemoModeEnabled } from '@/lib/supabase';
import type { Database } from '@/lib/database.types';

type Post = Database['public']['Tables']['posts']['Row'] & {
  author: {
    name: string;
    avatar_url: string | null;
  };
};

export function useBlogPost(slug: string) {
  const [post, setPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchPost() {
      if (!slug) return;
      
      try {
        setLoading(true);
        setError(null);

        // If in demo mode, add a slight delay to simulate network latency
        if (isDemoModeEnabled()) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
        
        const { data, error } = await supabase
          .from('posts')
          .select(`
            *,
            author:author_id(name, avatar_url)
          `)
          .eq('slug', slug)
          .single();

        if (error) throw error;
        if (data) setPost(data as Post);
      } catch (err) {
        console.error('Error loading post:', err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    fetchPost();
  }, [slug]);

  return { post, loading, error };
}